// // HORRIBLE STRUCTURE. RETHINK ME
// https://www.i18next.com/
// https://amiralearning.atlassian.net/browse/AE-1265
// react-i18next me
export const app = {
  errorHelpPrompt: "Please contact support@amiralearning.com for assistance.",
  errorsMessages: {
    armSpanish: "ARM is not supported for Spanish, please choose another metric.",
  },
  selectPanel: {
    classrooms: 'Classes',
    metrics: 'Metrics',
    levels: 'Levels',
    label: 'Select: '
  },
  selectRoster: {
    districts: 'Districts',
    schools: 'Schools',
    classrooms: 'Classes',
    students: 'Students',
  },
  miller: {
    placeholder: 'Start typing to see list'
  },
  pillars: {
    start: '0%',
    end: '100%',
    note: 'Click the bar for details',
  },
  splash: {
    button: 'View Full Report'
  },
  planningDetail: {
    header: {
      instruction: 'Instruction',
      practice: 'Practice',
    },
    rows: {
      monday: 'MONDAY',
      tuesday: 'TUESDAY',
      wednesday: 'WEDNESDAY',
      thursday: 'THURSDAY',
      friday: 'FRIDAY',
    }
  },
  diagnosticDetail: {
    header: {
      strengths: 'Strengths',
      weaknesses: 'Weaknesses',
    },
    types: {
      strength: 'STRENGTH',
      weakness: 'WEAKNESS',
      next: 'NEXT',
    },
    tooltip: 'Show more information about this diagnosis',
    info: 'Info',
  },
  trackingTable: {
    headers: [
      {
        label: 'Last Name',
        value: 'last_name',
        width: 130,
      },
      {
        label: 'First Name',
        value: 'first_name',
        width: 130,
      },
      {
        label: 'Tutoring Time',
        subtitle: 'This Week',
        value: 'tutoringMinutes',
        width: 116,
      },
      {
        label: 'Stories Read',
        subtitle: 'This Week',
        value: 'storyCount',
        width: 120,
      },
      {
        label: 'Review Skills',
        width: 100,
      },
      {
        label: 'Assessment Status',
        value: 'status',
        width: 230,
      },
      {
        label: 'Language',
        width: 120,
      }
    ],
  },
  progressReport: {
    headers: [
      {
        label: 'Activity Type',
        value: 'type',
      },
      {
        label: 'Score',
        value: 'score',
      },
      {
        label: 'Story Name',
        value: 'story_name',
      },
      {
        label: 'Story Grade',
        value: 'story_grade',
      },
      {
        label: 'Session Time',
        value: 'time_read',
      },
      {
        label: 'Date',
        value: 'value',
      }
    ]
  },
}

export const modal = {
  mountId: 'root'
}

export default {
  app,
  modal,
}